export default __webpack_public_path__ + "static/GenericImageActionListWithTitle-1863af3c2e6ece8f16f3e2c6c204e97d.jpg";